import COLORS from '../../../../utils/constants/colors'

const COL_WIDTHS = {
  drag: 24,
  index: 28,
  name: 240,
  date: 280,
  delete: 40,
}

const ROW_HEIGHT = 64

const bulkAddGamedaysModalStyles = (theme) => ({
  titleWrapper: {
    padding: 0,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  titleDot: {
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: COLORS.orange,
  },
  content: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  columnHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(0.5),
  },
  columnLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  requiredMark: {
    color: COLORS.orange,
    marginLeft: 2,
  },
  rowsContainer: {
    maxHeight: ROW_HEIGHT * 8,
    overflowY: 'auto',
    paddingRight: theme.spacing(0.5),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    minHeight: ROW_HEIGHT,
    borderRadius: 8,
    transition: 'background-color 120ms',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.02)',
    },
  },
  rowDragging: {
    backgroundColor: '#fff',
    boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
  },
  dragCol: {
    width: COL_WIDTHS.drag,
    display: 'flex',
    justifyContent: 'center',
    flexShrink: 0,
  },
  indexCol: {
    width: COL_WIDTHS.index,
    display: 'flex',
    justifyContent: 'center',
    flexShrink: 0,
  },
  nameCol: {
    width: COL_WIDTHS.name,
    flexShrink: 0,
  },
  dateCol: {
    width: COL_WIDTHS.date,
    flexShrink: 0,
  },
  deleteCol: {
    width: COL_WIDTHS.delete,
    display: 'flex',
    justifyContent: 'center',
    flexShrink: 0,
  },
  indexBadge: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: 'rgba(224, 114, 110, 0.15)',
    color: COLORS.orange,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 600,
  },
  dragHandle: {
    color: theme.palette.text.secondary,
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing',
    },
  },
  deleteButton: {
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.error.main,
    },
  },
  addRowButton: {
    width: '100%',
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    borderStyle: 'dashed',
    borderWidth: 1,
    textTransform: 'none',
    '&:hover': {
      borderStyle: 'dashed',
      backgroundColor: 'rgba(224, 114, 110, 0.04)',
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  switchControl: {
    marginLeft: 0,
  },
  errorMessage: {
    marginTop: theme.spacing(2),
    color: theme.palette.error.main,
    backgroundColor: 'rgba(244, 67, 54, 0.08)',
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: 4,
    padding: theme.spacing(1, 1.5),
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
  },
})

export default bulkAddGamedaysModalStyles
